// ══════════════════════════════════════════════════════════════
// COMPASS – User Signature Actions (US-013)
// ══════════════════════════════════════════════════════════════

import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserSignatureDto } from '../../api/models/user-signature-dto';

export const UserSignatureActions = createActionGroup({
  source: 'User Signature',
  events: {
    // The caller's own signature; none stored yet is a success with null (the backend answers 404)
    'Load Signature': emptyProps(),
    'Load Signature Success': props<{ signature: UserSignatureDto | null }>(),
    'Load Signature Failure': props<{ error: string }>(),
    // Not a Compliance Officer in any company (403): no signature to manage
    'Load Signature Forbidden': emptyProps(),

    // Set or replace; the signature card shows a failure itself, next to the file (no toast)
    'Upload Signature': props<{ file: File }>(),
    'Upload Signature Success': props<{ signature: UserSignatureDto }>(),
    'Upload Signature Failure': props<{ error: string }>(),
  },
});
